const RemovePurchaser = (data, setData) => {
  if (data.purchasersNum < 5) {
    let count;
    count = data.purchasersNum - 1;
    setData({ ...data, purchasersNum: count });
  }
};

export default RemovePurchaser;
